<template>
  <div id="options">
    <div class="container pt-4">
      <div v-if="$store.state.translator.mode === 'pick'">
        <!-- Dataset Picker -->
        <DatasetPicker
          title="Select Dataset to Translate"
          stateDoc="dataset"
          stateGeoJson="datasetGeoJson"
          stateHeader="datasetHeader"
          stateLoading="datasetLoading"
          v-if="$store.state.translator.farm.id && !$store.state.translator.dataset.name"
        />
        <div v-if="$store.state.translator.dataset.name">
          <p class="mb-1"><strong>Selected Dataset</strong></p>
          <!-- SELECTED DATASET -->
          <div
            class="list-group-item list-group-item-action mb-2"
            style="background-color:lightgreen;"
          >
            <p class="lead mb-1">{{ $store.state.translator.dataset.name }}</p>
            <i
              class="fas fa-times-circle clickable"
              id="remove-dataset"
              @click="removeDataset('dataset')"
            ></i>
            <!-- LOADING DATASET SPINNER -->
            <div
              v-if="$store.state.translator.datasetLoading"
              class="loading-dataset-spinner"
            >
              <RingLoader
                :color="'#61539b'"
                id="spinner"
              ></RingLoader>
            </div>
          </div>
          <p class="mb-1"><strong>Dataset Header</strong></p>
          <b-form-group class="mb-1" description="Select a header to translate.">
            <b-form-select
              v-model="datasetHeader"
              :options="$store.state.translator.dataset.headers"
              @change="optionsChanged()"
            ></b-form-select>
          </b-form-group>
          <DatasetPicker
            title="Select Sample Points Dataset"
            stateDoc="samplesDataset"
            stateGeoJson="samplesDatasetGeoJson"
            stateHeader="samplesDatasetHeader"
            stateLoading="samplesDatasetLoading"
            v-if="!$store.state.translator.samplesDataset.name"
          />
          <div v-if="$store.state.translator.samplesDataset.name">
            <p class="mb-1"><strong>Selected Samples Dataset</strong></p>
            <!-- SELECTED SAMPLES DATASET -->
            <div
              class="list-group-item list-group-item-action mb-2"
              style="background-color:lightgreen;"
            >
              <p class="lead mb-1">{{ $store.state.translator.samplesDataset.name }}</p>
              <i
                class="fas fa-times-circle clickable"
                id="remove-dataset"
                @click="removeDataset('samplesDataset')"
              ></i>
              <!-- LOADING DATASET SPINNER -->
              <div
                v-if="$store.state.translator.sampleDatasetLoading"
                class="loading-dataset-spinner"
              >
                <RingLoader
                  :color="'#61539b'"
                  id="spinner"
                ></RingLoader>
              </div>
            </div>
            <p class="mb-1"><strong>Samples Dataset Header</strong></p>
            <b-form-group class="mb-1" description="Select a header to use for the translation.">
              <b-form-select
                v-model="samplesDatasetHeader"
                :options="$store.state.translator.samplesDataset.headers"
                @change="optionsChanged()"
              ></b-form-select>
            </b-form-group>
          </div>
        </div><!-- End Dataset settings -->

        <!-- VIEW CORRELATION -->
        <Correlation
          class="mt-3"
          v-if="!hideCorrelation && $store.state.translator.dataset.name && $store.state.translator.datasetHeader && $store.state.translator.samplesDataset.name && $store.state.translator.samplesDatasetHeader"
        />

        <!-- TRANSLATE BUTTON -->
        <b-btn
          v-if="$store.state.translator.correlation > 0.01 && !$store.state.translator.runningTranslation || $store.state.translator.correlation < -0.01 && !$store.state.translator.runningTranslation"
          variant="success"
          @click="$store.dispatch('translator/runTranslation')"
          class="mt-1 w-100"
        >Run Translation</b-btn>
        <b-btn
          v-if="$store.state.translator.correlation > 0.01 && $store.state.translator.runningTranslation || $store.state.translator.correlation < -0.01 && $store.state.translator.runningTranslation"
          variant="light"
          class="mt-1 w-100"
        ><i class="fas fa-sync fa-spin"></i> Running Translation...</b-btn>
      </div><!-- /v-if pick mode -->

      <div v-if="$store.state.translator.mode === 'save'">
        <b-btn
          @click="$store.commit('translator/setStateProperty', { property: 'mode', value: 'pick' })"
          class="btn-sm"
        >← Back</b-btn>
        <p class="mb-1 mt-2" v-if="$store.state.translator.translationGeoJson.features">
          <span class="text-success">Success!</span><br>
          <strong>Save Translated Dataset</strong>
        </p>
        <!-- CHOOSE LOCATION -->
        <b-form-group
          label="New Dataset Name:"
          v-if="$store.state.translator.translationGeoJson.features"
        >
          <b-form-input v-model="post.name"></b-form-input>
        </b-form-group>

        <FolderPicker v-if="$store.state.translator.translationGeoJson.features" class="mb-2"/>

        <b-btn
          @click="$store.dispatch('translator/download')"
          class="mr-1"
          v-if="$store.state.translator.translationGeoJson.features"
        >Download</b-btn>
        <b-btn
          v-if="!$store.state.translator.posting && $store.state.translator.translationGeoJson.features"
          @click="$store.dispatch('translator/post')"
          variant="success"
        >Add to Every.Farm</b-btn>
        <b-btn
          v-if="$store.state.translator.posting"
          variant="light"
        ><i class="fas fa-sync fa-spin"></i> Adding now...</b-btn>
      </div><!-- /v-if save mode -->
    </div><!-- /.container -->
  </div><!-- /#options -->
</template>

<script>
import Correlation from './Correlation'
import DatasetPicker from './DatasetPicker'
import FolderPicker from './FolderPicker'
import RingLoader from 'vue-spinner/src/GridLoader'

export default {
  data () {
    return {
      hideCorrelation: false
    }
  },
  components: {
    Correlation,
    DatasetPicker,
    RingLoader,
    FolderPicker
  },
  computed: {
    datasetHeader: {
      get () {
        return this.$store.state.translator.datasetHeader
      },
      set (value) {
        this.$store.commit('translator/setStateProperty', { property: 'datasetHeader', value: value })
      }
    },
    samplesDatasetHeader: {
      get () {
        return this.$store.state.translator.samplesDatasetHeader
      },
      set (value) {
        this.$store.commit('translator/setStateProperty', { property: 'samplesDatasetHeader', value: value })
      }
    },
    post: {
      get () {
        return this.$store.state.translator.post
      },
      set (value) {
        this.$store.commit('translator/setStateProperty', { property: 'post', value: value })
      }
    }
  },
  methods: {
    optionsChanged () {
      this.hideCorrelation = true
      setTimeout(() => {
        this.hideCorrelation = false
      }, 10)
      this.$store.commit('translator/setStateProperty', { property: 'translationGeoJson', value: {} })
    },
    removeDataset (stateVar) {
      this.$store.commit('translator/setStateProperty', { property: stateVar, value: {} })
      const mapObject = this.$store.state.translator.mapObject
      if (mapObject.getLayer(stateVar + 'Preview')) {
        mapObject.removeLayer(stateVar + 'Preview')
        mapObject.removeSource(stateVar + 'Preview')
      }
      if (mapObject.getLayer(stateVar + 'PreviewOutline')) {
        mapObject.removeLayer(stateVar + 'PreviewOutline')
        mapObject.removeSource(stateVar + 'PreviewOutline')
      }
      this.$store.commit('translator/setStateProperty', { property: 'translationGeoJson', value: {} })
    }
  }
}
</script>

<style scoped>
/* Leave room for the shared 56px plugin header at the top. */
#options {
  position: absolute;
  top: 56px;
  left: 0;
  height: calc(100% - 56px);
  width: 300px;
  z-index: 1;
  overflow-y: scroll;
  padding-bottom: 50px;
  background: #fff;
  border-right: 1px solid #d6dbe0;
}

#remove-dataset {
  position: absolute;
  top: 10px;
  right: 10px;
}

.loading-dataset-spinner {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(255,255,255,0.3);
  width: 100%;
  height: 100%;
}
.v-spinner {
  position: absolute;
  left: calc(50% - 30px);
  top: 16px;
}

@media (max-width: 600px) {
  #options {
    top: 60%;
    height: 40%;
    width: 100%;
  }
}
</style>
